import { useState, useCallback } from "react";
import AuthenticatorModal from "../authentificator/authentidicatoreModal";
import OTPCodeVerify from "../otp/OTPCodeVerify";

export const useSecurityFlow = ({ twoFaEnabled = false } = {}) => {

  const [step, setStep] = useState(null);
  const [pendingAction, setPendingAction] = useState(null);

  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));

  const username = currentUser?.user?.username;

  const runSecureAction = useCallback((action) => {
    setPendingAction(() => action);

    if (twoFaEnabled) {
      setStep("2fa");
    } else {
      setStep("otp");
    }
  }, [twoFaEnabled]);

  const handle2FASuccess = useCallback(() => {
    setStep("otp");
  }, []);

  const handleOtpSuccess = useCallback(async () => {
    const action = pendingAction;

    setPendingAction(null);
    setStep(null);

    if (action) {
      await action();
    }
  }, [pendingAction]);

  const handleCancel = useCallback(() => {
    setStep(null);
    setPendingAction(null);
  }, []);

  const modals = (
    <>
      {step === "2fa" && (
        <AuthenticatorModal
          visible={true}
          onClose={handleCancel}
          username={username}
          onSuccess={handle2FASuccess}
        />
      )}

      {step === "otp" && (
        <OTPCodeVerify
          isOpen={true}
          onCancel={handleCancel}
          onVerified={handleOtpSuccess}
          title="Confirmer votre adresse mail"
          message="Un code de vérification vous a été envoyé."
        />
      )}
    </>
  );

  return {
    runSecureAction,
    modals,
    step, // utile debug (optionnel)
  };
};